// logout.component.ts
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register-successfully',
  templateUrl: 'register-successfully.component.html',
  standalone:true
})
export class RegisterSucessfullyComponent {
  constructor(private router: Router) {

    this.router.navigate(['/']); 
  }

  
}
